import { Outlet } from 'react-router-dom'
import { Suspense } from 'react'

import { BottomNav } from '../components/layout/BottomNav'
import { PageTransition } from './PageTransition'
import { Splash } from './Splash'

/**
 * The tab roots share one nav so it never unmounts — remounting it on every
 * navigation loses the press state, makes the bar flicker on a slow device and
 * would stop the selection capsule sliding from one tab to the next.
 * The bar floats over the screen (Figma Tab Bar), so the page is marked
 * `tabbed` and every scroll area ends clear of it.
 */
export function TabShell(): JSX.Element {
  return (
    <>
      <Suspense fallback={<Splash />}>
        <PageTransition tabbed>
          <Outlet />
        </PageTransition>
      </Suspense>
      <BottomNav />
    </>
  )
}
